module.exports = __webpack_public_path__ + "media/src/img/flag_of_kyrgyzstan_like_kz_proportion2-a3b94c64b89ceb946777c005f02a981f.svg";